import { NgModule, Optional, SkipSelf } from "@angular/core";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from "@ngx-translate/core";
import { ThemeService } from "./themes";
import { CORE_SERVICES } from "./services";

@NgModule({
  imports: [BrowserAnimationsModule, TranslateModule],
  providers: [
    ThemeService,
    ...CORE_SERVICES,
  ],
  exports: [BrowserAnimationsModule]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
